<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="detail-bg"></div>
    <div class="container">
      <div class="page-header">
        <div class="icon-bar back" @click="handleBack"></div>
        <div class="page-title sub">{{ $t('accountpage.text8') }}</div>
      </div>
      <div class="detail-box">
        <div class="list-title6">
          {{ $t('web5token') }}<br /><br />
          <span class="price">1,000</span> = 1 USDT
        </div>
        <div class="list-title6">{{ $t('add.text19') }}</div>
        <CopyBox :copyText="address" />
        <div class="qrcode-box">
          <div class="qrcode" id="qrCodeUrl"></div>
        </div>
        <div class="min-tip">
          {{ $t('add.text41', { price: '5 USDT' }) }}
        </div>
        <div class="title3 ac">· {{ $t('add.text20') }} ·</div>
        <div class="icon-block type2">
          <a class="icon metamask" href="https://metamask.io" target="_blank">{{
            $t('add.metamask')
          }}</a>
          <a class="icon imtoken" href="https://token.im" target="_blank">{{
            $t('add.imtoken')
          }}</a>
          <a class="icon bitkeep" href="https://bitkeep.io" target="_blank">{{
            $t('add.bitkeep')
          }}</a>
        </div>
        <div class="title3">· {{ $t('add.tips') }} ·</div>
        <div class="pp">
          {{ $t('add.text21') }}
        </div>
        <div class="pp help">
          {{ $t('add.text22') }}<br />
          {{ $t('add.text23') }}
          <a class="link" href="https://t.me/krazeglobebot" target="_blank">{{
            $t('add.text24')
          }}</a>
        </div>
      </div>
      <div class="footer">
        <el-button
          type="primary"
          @click="handleDeposit"
          class="block el-button--special"
          style="color: #ffffff"
          >{{ $t('deposit') }}</el-button
        >
      </div>
      <div class="open-area" style="height: 1rem"></div>
    </div>
  </div>
</template>
<script>
import { postUsdtAddress, postUsdtQuery } from '@/api/user'
import CopyBox from '@/components/CopyBox.vue'
import QRCode from 'qrcodejs2'

export default {
  name: 'UserUsdtYes',
  components: {
    CopyBox
  },
  data() {
    return {
      address: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      postUsdtAddress().then((res) => {
        this.address = res.data.address
        this.creatQrCode(res.data.address)
      })
    },
    handleBack() {
      this.$router.back()
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    },
    creatQrCode(address) {
      let qrcode = new QRCode('qrCodeUrl', {
        width: 132,
        height: 132,
        text: address, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    handleDeposit() {
      postUsdtQuery().then((res) => {
        if (res.data.status === 0) {
          this.$toast({
            message: this.$t('add.text36'),
            iconClass: 'icon icon-warning'
          })
        } else {
          this.$toast({
            message: this.$t('successed'),
            iconClass: 'icon icon-success'
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/usdtyes.vue